var _rect, _g, _path, _path2, _path3, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    rx: 74.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_5887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149 0H0V149H149V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.075 0H0.0745239V149H149.075V0Z",
    fill: "url(#paint0_linear_454_5887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.074 0H0.0744629V149H149.074V0Z",
    fill: "url(#paint1_linear_454_5887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.074 0H0.0744629V149H149.074V0Z",
    fill: "url(#paint2_linear_454_5887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.074 0H0.0744629V149H149.074V0Z",
    fill: "url(#paint3_linear_454_5887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.074 0H0.0744629V149H149.074V0Z",
    fill: "url(#paint4_linear_454_5887)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_454_5887)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3242 111.877C69.3242 110.326 70.5695 109.069 72.1057 109.069H76.428C77.9642 109.069 79.2096 110.326 79.2096 111.877V116.24C79.2096 117.79 77.9642 119.047 76.428 119.047H72.1057C70.5695 119.047 69.3242 117.79 69.3242 116.24V111.877Z",
    fill: "#0FAF46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2942 99.4788C69.4454 100.886 70.6363 101.981 72.083 101.981H77.3911C78.8475 101.981 80.0447 100.871 80.1828 99.4503L97.4676 76.411C97.6064 76.2305 97.7431 76.0483 97.8776 75.8644L98.2348 75.3884L98.221 75.3852C101.52 70.6809 103.457 64.9504 103.457 58.7674C103.457 42.7691 90.4923 29.7998 74.5 29.7998C58.5077 29.7998 45.5434 42.7691 45.5434 58.7674C45.5434 64.3402 47.1165 69.5455 49.8426 73.9631L49.8156 73.9637L49.9644 74.1587C50.9064 75.6584 51.982 77.0655 53.1744 78.3635L69.2942 99.4788Z",
    fill: "url(#paint5_radial_454_5887)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_454_5887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 29,
    width: 59,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2942 99.4788C69.4454 100.886 70.6363 101.981 72.083 101.981H77.3911C78.8475 101.981 80.0447 100.871 80.1828 99.4503L97.4676 76.411C97.6064 76.2305 97.7431 76.0483 97.8776 75.8644L98.2348 75.3884L98.221 75.3853C101.52 70.681 103.457 64.9504 103.457 58.7674C103.457 42.7691 90.4923 29.7998 74.5 29.7998C58.5077 29.7998 45.5434 42.7691 45.5434 58.7674C45.5434 64.3402 47.1165 69.5455 49.8426 73.9631L49.8156 73.9637L49.9644 74.1587C50.9064 75.6584 51.982 77.0655 53.1744 78.3635L69.2942 99.4788Z",
    fill: "#333B47"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_454_5887)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6871 53.7427V66.1303C65.6871 66.9135 66.0025 67.6967 66.594 68.1927C66.9489 68.493 67.3826 68.6888 67.9215 68.6888H81.0653C81.5516 68.6888 81.9853 68.493 82.2613 68.2841C83.0105 67.7359 83.2865 67.031 83.2997 66.1172C83.2997 66.052 83.3128 66.0259 83.3128 65.9606V65.8562C83.2997 63.4805 83.3128 61.0787 83.3128 58.6899C82.6951 58.8988 82.0116 59.1598 81.6304 59.3556C81.591 59.3687 81.5516 59.3817 81.5121 59.4078V63.5457C81.5121 63.7807 81.499 63.9896 81.499 64.2115C81.499 64.6553 81.499 65.1121 81.499 65.569C81.499 66.4436 81.5647 66.9004 80.8287 66.9396C80.7104 66.9396 80.6052 66.9266 80.5001 66.9396C80.2241 66.9788 70.3268 66.9527 70.0508 66.9527C69.7748 66.9527 69.5382 66.9396 69.2753 66.9396C68.9073 66.9396 68.0792 66.9788 67.7901 66.8482C67.6061 66.7699 67.5009 66.5872 67.5009 66.3392C67.5009 66.2739 67.4878 66.2478 67.4878 66.1695C67.4878 66.1042 67.4878 66.0389 67.4878 65.9737C67.4878 65.8301 67.4746 65.7256 67.4746 65.5951L67.4615 61.6139C67.4615 61.0526 67.4746 60.5304 67.4746 59.9822V57.5282C67.4746 57.241 67.4878 57.006 67.4878 56.7189V54.2648C67.4878 53.9646 67.4615 53.3903 67.6718 53.2075C67.8558 53.0378 68.0792 53.0378 68.329 53.0378C68.421 53.0378 68.4473 53.0248 68.5261 53.0248C71.8252 52.9856 75.2163 53.0248 78.5022 53.0248C78.9097 53.0248 80.6972 52.9987 81.0127 53.0639C81.2624 53.1161 81.4201 53.2336 81.4727 53.4816C81.5121 53.7296 81.4727 54.0299 81.499 54.2909C81.5253 54.552 81.5121 54.8653 81.5121 55.1394C81.5121 55.4396 81.5253 55.6876 81.5253 55.9748V56.6797C82.0773 56.4578 82.6556 56.2489 83.2208 56.0923L83.3128 56.0531V54.2257C83.3128 53.56 83.234 52.8551 82.8791 52.3199C82.8397 52.2416 82.7871 52.1894 82.7345 52.111C82.3402 51.615 81.5516 51.2495 80.8944 51.2495H68.1318C67.8032 51.2495 67.422 51.3539 67.1197 51.4714C66.2128 51.85 65.6871 52.7506 65.6871 53.7427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2269 60.8302C75.1355 60.7643 74.8872 60.5009 74.7958 60.3956C74.5737 60.1849 74.3516 59.9742 74.1034 59.803L73.9728 59.7108C73.9336 59.6845 73.8813 59.6582 73.8421 59.6318C73.8029 59.5923 73.7507 59.566 73.7115 59.5397C73.1497 59.2631 72.601 59.0656 71.9609 58.8944C71.3992 58.7627 70.759 58.6047 70.1581 58.6705C70.0928 58.6837 70.0274 58.6969 69.9621 58.71C69.9621 58.9339 69.949 59.1051 69.949 59.329C69.949 59.5265 69.9229 59.7504 69.9229 59.9479C69.9229 60.3693 69.8837 60.7775 69.8837 61.1989C69.936 61.1989 69.936 61.1857 70.0013 61.1857C70.7982 61.1857 71.1379 61.1989 71.8564 61.4754C72.3006 61.6334 72.7055 61.8968 73.0583 62.1997C73.0844 62.226 73.0975 62.2392 73.1236 62.2655C73.2542 62.3577 73.3849 62.5025 73.4894 62.6211L73.607 62.7659C73.9205 63.1478 74.1557 63.4902 74.3908 63.9247C74.626 64.3724 74.8089 64.8333 74.9656 65.3074C74.9787 65.3732 75.0048 65.4654 75.0309 65.5181C75.1093 65.4786 75.2269 65.4523 75.3183 65.4259L76.2067 65.1362C76.3112 65.0967 76.4027 65.0704 76.4941 65.044L77.095 64.8465C77.1865 64.8202 77.3171 64.7938 77.3955 64.7543C77.3955 64.7148 77.3825 64.6622 77.3825 64.6095C77.3563 64.3856 77.3171 64.1354 77.3171 63.8984C77.3171 63.8325 77.3041 63.8194 77.3041 63.7535C77.2779 63.0161 77.3433 62.3709 77.5784 61.6729C77.7221 61.2252 77.9442 60.8302 78.2055 60.4483L78.3884 60.1981C78.5452 60.0137 78.8326 59.6845 79.0155 59.5397C79.1984 59.3816 79.3812 59.2236 79.5772 59.0656L79.8385 58.8812C80.0214 58.7496 80.2043 58.631 80.4002 58.5257C80.6485 58.3677 81.0273 58.1438 81.3017 58.0385C81.3539 58.0121 81.3931 57.9858 81.4454 57.9595C81.4976 57.9331 81.5499 57.9199 81.6021 57.8936C82.2292 57.5776 83.6401 57.0772 84.2933 56.8928L84.9988 56.6821C85.1163 56.6426 85.2339 56.6031 85.3646 56.5768C85.3254 56.5109 85.0771 55.4575 85.051 55.3521L84.8159 54.4435C84.7897 54.3513 84.7767 54.2196 84.7375 54.1406C84.5807 54.1538 83.3266 54.5488 83.1829 54.6015C82.5035 54.799 81.7981 55.0624 81.1449 55.3389C81.0796 55.3653 81.0273 55.3916 80.962 55.418L80.4394 55.6418C80.3872 55.6813 80.3349 55.7077 80.2696 55.734C80.152 55.7735 80.0344 55.8393 79.9299 55.892C79.6033 56.0764 79.2767 56.2476 78.9632 56.4583C78.5582 56.7216 78.1663 56.9982 77.7874 57.301C77.6568 57.4195 77.5131 57.5249 77.3825 57.6566C77.3433 57.7093 77.3041 57.7356 77.2518 57.7751C77.0428 57.9858 76.8207 58.1965 76.6378 58.4335L76.3112 58.8549C75.9324 59.3553 75.6188 59.882 75.3706 60.4483C75.3314 60.5273 75.2269 60.738 75.2269 60.8302Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_454_5887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2274 58.7674C51.2274 63.5237 52.3725 68.0123 54.4018 71.9719L49.3397 73.1205C46.924 68.8894 45.5434 63.9898 45.5434 58.7674C45.5434 42.7691 58.4993 29.7998 74.4812 29.7998C75.4402 29.7998 76.3882 29.8465 77.3232 29.9377C62.6752 31.3671 51.2274 43.729 51.2274 58.7674ZM67.9113 98.2622L74.4728 89.6617V99.1754C74.4728 100.661 75.6266 101.878 77.0863 101.975C77.0236 101.979 76.9604 101.981 76.8967 101.981H71.592C70.1365 101.981 68.9401 100.871 68.8021 99.4503L67.9113 98.2622ZM85.3838 92.0074V87.2653C86.9481 86.9801 88.4685 86.569 89.9342 86.0429L85.3838 92.0074Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_454_5887",
    x: 37.1502,
    y: 21.4066,
    width: 61.1772,
    height: 88.9681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19661,
    result: "effect1_foregroundBlur_454_5887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_5887",
    x1: 122.85,
    y1: 10.3555,
    x2: 38.9635,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FDAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#DDFA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86FECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_5887",
    x1: 15.4215,
    y1: 133.951,
    x2: 66.603,
    y2: 85.3025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98FFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#98FFD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_454_5887",
    x1: 138.272,
    y1: 114.283,
    x2: 105.864,
    y2: 80.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#CFFFB4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_454_5887",
    x1: 129.779,
    y1: 17.88,
    x2: 85.7495,
    y2: 62.5055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BFFE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_454_5887",
    x1: 19.221,
    y1: 6.3325,
    x2: 74.649,
    y2: 51.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BFFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BFFA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_454_5887",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.89 46.7728) rotate(45.3073) scale(43.0287 34.523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BDB88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CAD44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_5887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_454_5887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.5,
    height: 149,
    fill: "white",
    transform: "translate(37.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.bd27057546f473c1f73ca16c3164afc1.svg";
export { ForwardRef as ReactComponent };